import { render, staticRenderFns } from "./Hospitals.vue?vue&type=template&id=5d58ac84&lang=pug"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HospitalsList: require('/home/docker/code/frontend/components/HospitalsList.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
